import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedMovies from './components/FeaturedMovies';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蜜桃电影',
  url: 'https://mitaomovie.com/',
  description: '蜜桃电影为您精选海量优质影片资源，涵盖爱情、喜剧、动作、悬疑等多种类型，高清在线观看体验流畅。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://mitaomovie.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '蜜桃电影',
  url: 'https://mitaomovie.com/',
  description: '蜜桃电影 - 精选好片在线观看推荐平台',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '蜜桃电影提供哪些类型的影片推荐？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '蜜桃电影覆盖爱情、喜剧、动作、悬疑、科幻、动画、恐怖、纪录片等八大主流类型，每一部推荐影片都经过编辑团队精心筛选，确保为您提供高质量的观影选择。',
      },
    },
    {
      '@type': 'Question',
      name: '蜜桃电影是否需要注册或付费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '蜜桃电影是一个完全免费的影片推荐平台，无需注册即可浏览所有推荐内容。',
      },
    },
    {
      '@type': 'Question',
      name: '蜜桃电影的推荐标准是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们的编辑团队基于影片质量、观众口碑、类型代表性以及当下热度等多个维度进行影片筛选。',
      },
    },
    {
      '@type': 'Question',
      name: '如何找到适合自己口味的电影？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过首页的分类入口浏览不同类型的影片，也可以查看精选推荐栏目发现高分佳作。',
      },
    },
    {
      '@type': 'Question',
      name: '蜜桃电影的影评文章多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们保持每周至少更新2-3篇高质量影评文章的更新频率，热门档期会加大更新力度。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="蜜桃电影 - 精选好片在线观看推荐 | 高清资源热门推荐片单"
        description="蜜桃电影为您精选海量优质影片资源，涵盖爱情、喜剧、动作、悬疑等多种类型，高清在线观看体验流畅。无论您喜欢哪种风格，蜜桃电影都能满足您的观影需求，立即探索热门推荐片单，开启精彩观影之旅。"
        keywords="蜜桃电影,蜜桃电影在线观看,蜜桃电影高清资源,蜜桃电影热门推荐,蜜桃电影最新上映,蜜桃电影免费观看,蜜桃电影片单精选"
        canonicalUrl="https://mitaomovie.com/"
        ogType="website"
        schema={{ ...homepageSchema, ...orgSchema, ...faqSchema }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <FeaturedMovies />
          <LatestArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}